import { defineComponent as _defineComponent } from 'vue'
import VPreLoader from "@/components/vPreLoader.vue";
import {onMounted, ref} from "vue";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";
import * as dropin from "braintree-web-drop-in";
import {Dropin} from "braintree-web-drop-in";
import {useTranslations} from "@/hooks/useTranslations";
import {useNotify} from "@/hooks/useNotify";
import {BraintreeCountries} from "@/utils/BraintreeCountries";
import VAccordion from "@/components/vAccordion.vue";

type CreatePaymentMethodDto = {
  isDefault: boolean,
  billingAddress: {
    country: string,
    state: string,
    postalCode: string,
    city: string,
    addressLine: string,
    phoneNumber: string,
    firstName: string,
    lastName: string,
  },
  paymentMethodNonce: string,
  cardholderName: string,
}

type CreatePaymentMethodFormProps = {
  showCancel: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePaymentMethodForm',
  props: {
    showCancel: { type: Boolean, default: true }
  },
  emits: [
  "submit",
  "cancel"
],
  setup(__props: any, { emit }) {




const showPaymentPreloader = ref(false);
const braintreeDropInInstance = ref<Dropin>();
const dropinInitialized = ref(false);

const formData = ref<CreatePaymentMethodDto>({
  isDefault: false,
  billingAddress: {
    country: "",
    state: "",
    postalCode: "",
    city: "",
    addressLine: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
  },
  paymentMethodNonce: "",
  cardholderName: "",
});

const translations = useTranslations();
const notify = useNotify();

const dropinContainer = ref<HTMLDivElement>();
onMounted(async() => {
  dropinContainer.value.innerHTML = "";
  await initDropInInstance();
});

async function initDropInInstance() {

  showPaymentPreloader.value = true;
  const clientTokenResponse = await SubscriptionRepository.generateClientToken();

  try {
    braintreeDropInInstance.value = await dropin.create(
      {
        authorization: clientTokenResponse.data.result,
        container: document.getElementById("dropin"),
        paypal: {
          flow: "vault",
        },
        card: {
          cardholderName: {
            required: true,
          },
        },
      }
    );
  }

  catch (error) {
    console.error(error);
  }

  finally {
    dropinInitialized.value = true;
    showPaymentPreloader.value = false;
  }
}

async function handleCreatePaymentMethod() {
  braintreeDropInInstance.value.requestPaymentMethod((err, payload) => {
    if (err) {
      notify.error("Please check payment info.");
      return;
    }

    let createPaymentMethodDto = {
      IsDefault: formData.value.isDefault,
      BillingAddress: {
        Country: formData.value.billingAddress.country,
        State: formData.value.billingAddress.state,
        PostalCode: formData.value.billingAddress.postalCode,
        City: formData.value.billingAddress.city,
        AddressLine: formData.value.billingAddress.addressLine,
        PhoneNumber: formData.value.billingAddress.phoneNumber,
        FirstName: formData.value.billingAddress.firstName,
        LastName: formData.value.billingAddress.lastName,
      },
      PaymentMethodNonce: payload.nonce,
    };

    // @ts-ignore
    notify.async(
      "Creating payment method..",
      () =>
        new Promise<void>((resolve, reject) => {
          createPaymentMethod(createPaymentMethodDto)
            .then(resolve)
            .catch(reject);
        }),
      {
        timeout: 1000,
        closeOnClick: true,
      }
    );
  });
}

async function createPaymentMethod(dto) {
  try {
    await SubscriptionRepository.createPaymentMethod(dto);
    notify.success("Successfully created new payment method.");
    emit('submit');
  }

  catch (error) {
    if (error.response) {
      notify.error(error.response.data.errorMessages[0].userVisibleMessage);
    }

    else {
      notify.error(translations.value.get("network-error"));
    }
  }
}

return { __sfc: true,emit, showPaymentPreloader, braintreeDropInInstance, dropinInitialized, formData, translations, notify, dropinContainer, initDropInInstance, handleCreatePaymentMethod, createPaymentMethod, VPreLoader, BraintreeCountries, VAccordion }
}

})